import { MARQUEE_ITEMS } from "@/data";

const Track = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display italic text-3xl sm:text-5xl px-8 text-[#1C130E] whitespace-nowrap">{item}</span>
        <span className="w-2 h-2 rounded-full bg-[#C85A32]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="py-12 lg:py-16 overflow-hidden border-y border-[rgba(28,19,14,0.12)]">
    <div className="flex w-max marquee-track">
      <Track />
      <Track hidden />
    </div>
  </section>
);
